"use strict";

/**
 * Adds `.disable-transition-on-resize` to <body> while the window is being
 * resized so CSS transitions don't fire mid-drag. Class is removed 400ms
 * after the last resize event fires.
 *
 * The CSS that suppresses transitions/animations lives in
 * src/css/utilities/helpers.css.
 */
const disableTransitionOnResize = {
    initialized: false,
    init() {
        if (this.initialized) return;
        this.initialized = true;
        let resizeTimer;
        window.addEventListener("resize", () => {
            document.body.classList.add("disable-transition-on-resize");
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                document.body.classList.remove("disable-transition-on-resize");
            }, 400);
        });
    },
};

export default disableTransitionOnResize;
